import React, { useState } from 'react';

export default function EduPortalLogo({ size = 'md', className = '', showText = true }) {
  const [imgError, setImgError] = useState(false);

  const sizeClasses = {
    sm: { img: 'h-8', text: 'text-lg', box: 'w-8 h-8 text-sm' },
    md: { img: 'h-9', text: 'text-xl', box: 'w-9 h-9 text-base' },
    lg: { img: 'h-12', text: 'text-2xl', box: 'w-12 h-12 text-xl' },
    xl: { img: 'h-16', text: 'text-3xl', box: 'w-16 h-16 text-2xl' }
  }[size] || { img: 'h-9', text: 'text-xl', box: 'w-9 h-9 text-base' };

  return (
    <div className={`inline-flex items-center gap-3 select-none ${className}`}>
      {!imgError ? (
        <img
          src="/assets/eduportal-logo.png"
          onError={() => setImgError(true)}
          alt="EduPortal Logo"
          className={`${sizeClasses.img} w-auto object-contain max-w-full rounded-xl shadow-sm transition-transform duration-300 hover:scale-105`}
        />
      ) : (
        <div className={`${sizeClasses.box} rounded-xl bg-gradient-to-tr from-blue-600 to-purple-600 flex items-center justify-center text-white font-black shadow-lg shadow-blue-500/20 border border-white/20`}>
          EP
        </div>
      )}
      
      {showText && (
        <span className={`font-serif font-extrabold tracking-tight ${sizeClasses.text} bg-gradient-to-r from-slate-100 via-slate-200 to-slate-300 bg-clip-text text-transparent`}>
          Edu<span className="text-blue-400 font-sans">Portal</span>
        </span>
      )}
    </div>
  );
}
